'use strict';
import angular from 'angular';
import snapChatFrequencyHtmlUrl from './views/snapChat.frequency.html';

var app = angular.module('app.snapChatFrequencyComponent', []);

app.component('snapChatFrequency', {
    bindings: {
        showActions: '=',
        sets: '='
    },
    templateUrl: snapChatFrequencyHtmlUrl,

    // The controller that handles our component logic
    controller: function() {
        var self = this;
        self.frequency_cap_intervals = ['days', 'hours'];
        self.frequency_cap_type = ['impressions', 'swipes', 'video views 15 sec', 'video views', 'story opens', 'uses'];

        self.initComponent = function() {
            if(self.sets && self.sets.length >0){
                if(typeof self.sets == 'string') {
                    self.sets = JSON.parse(self.sets);
                }
                if(self.showActions){
                    self.showFrequencyView = false;
                    self.enableEditView = true;
                }else {
                    self.showFrequencyView = true;
                    self.enableEditView = false;
                }

            }else {
                self.sets = [
                    {
                        frequency_cap_count: null,
                        frequency_cap_type : '',
                        time_interval: null,
                        frequency_cap_interval: ''
                    }
                ];
                self.showFrequencyView = false;
            }
        };

        self.initComponent();
    }
});